import { BUILD_TOKEN } from './build-info';

export const environment = {
  production: false,
  api: '/api',
  buildToken: BUILD_TOKEN
};
